import { formatDistanceToNow } from 'date-fns'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { type EmailTemplate } from '@/models/emailTemplate'

interface TemplateListItemProps {
  template: EmailTemplate
  selected: boolean
  onSelect: () => void
}

export function TemplateListItem({ template, selected, onSelect }: TemplateListItemProps) {
  const updated = template.updatedAt
    ? formatDistanceToNow(new Date(template.updatedAt), { addSuffix: true })
    : null

  return (
    <Button
      variant="outlineThin"
      onClick={onSelect}
      aria-current={selected || undefined}
      className={cn(
        'h-auto w-full flex-col items-stretch gap-0.5 px-3 py-2 text-left font-normal whitespace-normal',
        selected && 'border-blue-500 bg-blue-50 hover:bg-blue-50'
      )}
    >
      <span className="flex items-center justify-between gap-2">
        <span className="truncate font-medium">{template.displayName || 'Untitled'}</span>
        {template.isDefault && (
          <Badge variant="secondary" className="shrink-0">
            Your default
          </Badge>
        )}
      </span>
      {updated && <span className="text-muted-foreground text-xs">Updated {updated}</span>}
    </Button>
  )
}
